module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAGFBMVEUAAADAs7DAsrG/tra/srD39vb////RyMYOXKwlAAAABHRSTlMA6aYc+fzKlQAAAFZJREFUSMdjGAX0BsyKLgSAkAGDoQtBIMygQliRE4MIYUWODCASj5PB8qOKRhUNa0Wl4UQoCkulVBHCusEXBKOKRhVRWRFRFRBRVRlRlSJx1esooDMAAGGsqGlCYrSiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/download_icon_pad_default.png
// module id = uyLL
// module chunks = 10